import React from "react" ;
import AppBodyNotificationDropdown from "root/Wieldy/ApplicationModules/Common/Body/AppBodyNotificationDropdown";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {MessageFilters, MessageMenuTitles} from "root/DataFunctions/Constants";

const MessagingAppBodyHeader= (props) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    const displayHeader = () =>
    {
        switch (queryParams.type)
        {
            case MessageFilters.ALL:
                return <h4 className="title">{MessageMenuTitles.ALL}</h4>
                break;

            case MessageFilters.PENDING:
                return <h4 className="title">{MessageMenuTitles.PENDING}</h4>
                break;

            case MessageFilters.INCOMING:
                return <h4 className="title">{MessageMenuTitles.INCOMING}</h4>
                break;

            case MessageFilters.DRAFT:
                return <h4 className="title">{MessageMenuTitles.DRAFT}</h4>
                break;

            case MessageFilters.SENT:
                return <h4 className="title">{MessageMenuTitles.SENT}</h4>
                break;

            default:
                return <h4 className="title">{MessageMenuTitles.INCOMING}</h4>
                break;
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}
        </div>
    ) ;
}

export default MessagingAppBodyHeader;
